import Intersection from "./Intersection";
import OrganisationsRoutes from "./Organisations";
import Router from "./Router";
import Routes from "./Routes";

export { OrganisationsRoutes, Routes, Intersection };

export default Router;
